var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.ticketEventList, function(each) {
        return _c(
          "div",
          {
            key: each.id,
            staticStyle: {
              "white-space": "nowrap",
              "text-overflow": "ellipsis",
              overflow: "hidden",
              "padding-right": "20px"
            },
            attrs: {
              title:
                each.ticketTitle +
                " " +
                each.operateContent +
                " " +
                (each.assignUserId || "")
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm._f("ticketTime")(each.createdAt)))]),
            _vm._v(" "),
            _c("span", { staticStyle: { color: "DarkGray" } }, [
              _vm._v("在工单")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticStyle: { color: "#409eff" },
                attrs: { href: "/ticket/t/" + each.orderId }
              },
              [_vm._v(_vm._s(each.ticketTitle || each.orderId))]
            ),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(each.operateContent))]),
            _vm._v(" "),
            each.assignUserId
              ? _c(
                  "span",
                  [
                    _vm._v("\n      给\n      "),
                    _c("TicketUser", { attrs: { userId: each.assignUserId } })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      }),
      _vm._v(" "),
      !_vm.ticketEventList || _vm.ticketEventList.length < 1
        ? _c("div", [_vm._v("ticketEventList is null or empty ...")])
        : _vm._e(),
      _vm._v(" "),
      _c("el-pagination", {
        staticStyle: { "padding-top": "20px" },
        attrs: {
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
          "pager-count": 6,
          "current-page": _vm.ticketEventPage.pageNumber,
          "page-sizes": [10, 25, 35, 50, 100],
          "page-size": _vm.ticketEventPage.pageSize,
          total: _vm.ticketEventPage.recordCount || 0
        },
        on: {
          "size-change": _vm.handleSizeChange_TicketEvent,
          "current-change": _vm.listTicketEvent
        }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h4", { staticStyle: { "margin-top": "40px" } }, [_vm._v("动态")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2de74e64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2de74e64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/UserTicketEventList.vue
// module id = 1038
// module chunks = 75